// TODO: TS: check ts

import type { ClassNameValue } from "tailwind-merge";

import { twMerge } from "tailwind-merge";

export const cn = (...inputs: ClassNameValue[]): string => {
  return twMerge(...inputs);
};

export function isTrimmedEmpty(value: unknown): boolean {
  if (value === undefined || value === null) return true;
  return String(value).trim() === "";
}

export const getCSSVar = (variable: string): string => {
  return getComputedStyle(document.documentElement).getPropertyValue(variable).trim();
};

export const resolveCssVar = (value: string | undefined): string | undefined => {
  if (!value) return value;
  const match = value.match(/var\((--[^)]+)\)/);
  if (match) return getCSSVar(match[1]);
  return value;
};

type InputDefaultStyleArgs = {
  disabled?: boolean;
  HasError?: boolean;
  isEmpty?: boolean;
};

export const getInputDefaultStyles = ({ disabled, HasError, isEmpty }: InputDefaultStyleArgs) => {
  if (HasError) {
    return {
      labelColor: "var(--color-purpose-status-negative)",
      textColor: "var(--color-purpose-status-negative)",
    };
  }
  if (disabled) {
    return {
      labelColor: "var(--color-foreground-disabled)",
      textColor: "var(--color-foreground-disabled)",
    };
  }
  return {
    labelColor: "var(--color-foreground-muted)",
    textColor: isEmpty ? "var(--color-foreground-muted)" : "var(--color-foreground-primary)",
  };
};
